import { IconButton } from '../iconButton/IconButton'
import classes from './Filters.module.sass'
import filter from '../../../assets/images/icons/filter.svg'
import filter_off from '../../../assets/images/icons/filter_off.svg'
import { useFilter } from './hooks/useFilters'
import { Button } from '../button/Button'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'
import { useSelector } from 'react-redux'
import { JSX } from 'react'

type Props = {
  children?: JSX.Element | JSX.Element[]
  clearFilters?: () => void
  filtersDirty?: boolean
  activateFilters?: () => void
  filtersChanged:boolean
}

export const Filters = ({ children, clearFilters, filtersDirty, activateFilters, filtersChanged }: Props) => {
  const { expanded, toggleExpanded } = useFilter()
  const dark = useSelector(selectDarkTheme)

  return (
    <div>
      {expanded && (
        <div className={dark ? classes.ContainerDark : classes.Container} onClick={e=>e.stopPropagation()}>
          <div className={classes.Title}>Фильтры</div>
          <div className={classes.FiltersContainer}>{children}</div>
          <div className={classes.ButtonContainer}>
            <Button
              text="Очистить фильтры"
              onClick={() => {
                if (clearFilters) {
                  clearFilters()
                  toggleExpanded()
                }
              }}
              small
              disabled={filtersDirty}
            />

            <Button
              text={filtersChanged ? 'Применить' : 'Закрыть'}
              onClick={() => {
                if (!filtersDirty && activateFilters) {
                  activateFilters()
                }
                toggleExpanded()
              }}
              small
            />
          </div>
        </div>
      )}
      <IconButton
        onClick={toggleExpanded}
        icon={!filtersDirty ? filter : filter_off}
        alt="Фильтр"
        display
      />
    </div>
  )
}
